export default __webpack_public_path__ + "static/media/thaigo-screenshot-01.be8a7cb5.png";